<template>
    <html>
    <body style="position: relative;background: #fff">
        <!--banner-->
        <!-- <div class="nding">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/zhihui/zhihui">智慧农业</a>&gt; <a href="">智慧农业物联网</a>
            </div>
        </div> -->
        <div class="banner"> <img src="@/assets/styles/images-link/ban4.png" alt=""> </div>
        <section class="section container03">
            <div class="da">
                <div class="zuo">
                    <h2>系统介绍</h2>
                    <h4>System Introduction</h4>
                    <p>农业物联网就是在大棚等系统中，安装大量的传感器构成监测网络，通过各种传感器采集信息，经过数据分析处理，依托自动化，智能化，远程控制生产的设备，来远程控制农作物生长条件，使之可以在最适宜的条件下生长，从而不受季节环境等因素的限制。 </p>
                </div>
                <img src="@/assets/styles/images-link/z1.png" alt="">
            </div>
        </section>
        <section class="section container06">
            <div class="da" style="height:auto">
                <div class="zuo">
                    <h2>应用领域</h2>
                    <h4>Application Fields</h4>
                </div>
                <ul>
                    <li> <img src="@/assets/styles/images-link/z2.png" alt="" class="img1"> </li>
                    <li>
                        <div class="sh">
                            <!-- <img src="@/assets/styles/images-link/icon1.png" alt=""> -->
                            <h2>大棚</h2>
                        </div>
                        <p>农业进入信息化时代，对温室内的空气温湿度、土壤温湿度、CO2浓度及光照等农业环境信息的采集也越来越重视。因此，实现温室种植的高效和精准化管理，将物联网技术引入温室大棚中来。物联网技术可应用到温室生产的不同阶段，把不同阶段植物的表现和环境因子进行分析反馈到下一轮的生产中，从而实现更精准的管理，获得更优质的产品。</p>
                    </li>
                    <li><img src="@/assets/styles/images-link/z3.png" alt="" class="img1"> </li>
                    <li>
                        <div class="sh">
                            <!-- <img src="@/assets/styles/images-link/icon2.png" alt=""> -->
                            <h2>大田</h2>
                        </div>
                        <p>农业大田种植智能管理系统针对农业大田种植分布广、监测点多、布线和供电困难等特点，利用物联网技术，采用高精度土壤温湿度传感器和智能气象站，远程在线采集水稻田土壤墒情、酸碱度、养分、气象信息等，实现墒情自动预报、灌溉用水量智能决策、远程、自动控制灌溉设备等功能，达到水稻精耕细作、准确施肥、合理灌溉的目的。</p>
                    </li>
                    <li><img src="@/assets/styles/images-link/z4.png" alt="" class="img1"> </li>
                    <li>
                        <div class="sh">
                            <!-- <img src="@/assets/styles/images-link/icon3.png" alt=""> -->
                            <h2>畜牧业</h2>
                        </div>
                        <p>在畜牧养殖中，农业物联网可以利用信息技术搭建智能控制系统实现畜禽养殖环境和水环境的自动化检测、控制，降低养殖风险达到增产增质的效果。采用物联网畜牧业平台，使畜生的生存一直处于最佳的环境中，通过平台化监控，自动化控制，很大幅度降低人工成本和劳动强度。</p>
                    </li>
                </ul>
            </div>
        </section>
        <section class="section container03">
            <div class="da">
                <div class="zuo">
                    <h2>物联网架构</h2>
                    <h4>IoT Architecture</h4>
                </div>
                <img src="@/assets/styles/images-link/z5.png" alt="">
            </div>
        </section>
        <section class="section container03" style="background:#f5f5f5">
            <div class="da">
                <div class="zuo">
                    <h2 style="color: #39bf3e">物联网应用系统</h2>
                    <h4 style="color: #39bf3e">IoT Application System</h4>
                    <p style="color: #333">通过各终端信息采集反馈，用户可对随时查看、分析大棚实时和历史数据，可以对土壤温度、CO2、氧气浓度等数据进行数据透视，并结合终端设备进行及时调整和管理。</p>
                </div>
                <img src="@/assets/styles/images-link/z6.png" alt="">
            </div>
        </section>
        <section class="section container077">
            <div class="da">
                <div class="zuo" style="background: #f8f8f8">
                    <h2>智慧灌溉系统</h2>
                    <h4>Intelligent Irrigation System</h4>
                    <img src="@/assets/styles/images-link/z7.png" alt="">
                    <p>智能灌溉系统是通过在田地间均匀安排分部灌溉龙头，自动采集，处理温度、湿度、风速、雨量、光照等环境参数汇总到控制系统，在控制系统的控制下可实现智能灌溉。</p>
                </div>
                <div class="zuo">
                    <h2>智慧农田水肥一体化</h2>
                    <h4>Fertigation</h4>
                    <img src="@/assets/styles/images-link/z8.png" alt="">
                    <p>水肥一体化技术是将灌溉与施肥融为一体的农业新技术。它是借助压力系统(或地形自然落差)，将可溶性固体或液体肥料，按土壤养分含量和作物种类的需肥规律和特点，配兑成的肥液与灌溉水一起，通过可控管道系统供水、供肥，使水肥相融后，通过管道、喷枪或喷头形成喷灌、均匀、定时、定量，喷洒在作物发育生长区域，使主要发育生长区域土壤始终保持疏松和适宜的含水量，同时根据不同的作物的需肥特点，土壤环境和养分含量状况，需肥规律情况进行不同生育期的需求设计，把水分、养分定时定量，按比例直接提供给作物。</p>
                </div>
            </div>
        </section>
        <section class="section container08">
            <div class="da">
                <div class="zuo">
                    <h2 style="color: #39bf3e">物联网设备</h2>
                    <h4 style="color: #39bf3e">IoT Devices</h4>
                </div>
                <ul>
                    <li>
                        <img src="@/assets/styles/images-link/z9.png" alt="">
                        <p>卷膜机</p>
                    </li>
                    <li>
                        <img src="@/assets/styles/images-link/z10.png" alt="">
                        <p>光照传感器 </p>
                    </li>
                    <li>
                        <img src="@/assets/styles/images-link/z11.png" alt="">
                        <p>空气温湿度传感器 </p>
                    </li>
                    <li>
                        <img src="@/assets/styles/images-link/z12.png" alt="">
                        <p>土壤温度、水分传感器</p>
                    </li>
                </ul>
            </div>
        </section>
    </body>
</html>
</template>


<script>

    import '@/assets/styles/css/zhihui.css';   
    export default {
        name: '',
        components: {},
        data: () => {
            return {

            };
        },
        created() {
            let wintitle = `${window.document.title}`;
            let title = wintitle.split('-')
            window.document.title = '农业物联网管理系统 - ' + title[1];
        },

        methods: {

        },
    }
</script>
